export default "__VITE_ASSET__cf8781f4__"